// import CleverTapReact from 'clevertap-react';
// import { isMobile } from 'react-device-detect';
// import { storageService } from 'services';
// import { environment } from 'environments/environment';

// const version = require('../../package.json').version;
// const REACT_APP_CLEVERTAP_KEY = environment.REACT_APP_CLEVERTAP_KEY;

export default class CleverTapAnalytics {
  static user_id = '';

  static initializeCTAnalytics() {
    // CleverTapReact.initialize(REACT_APP_CLEVERTAP_KEY);
  }

  // static configureProfile(userID: string, name: string | null, email: string | null) {
  //   CleverTapReact.profile({
  //     'Site': {
  //       Name: name || '',
  //       Email: email || '',
  //       Identity: userID,
  //     },
  //   });
  // }

  static async event({
    event_name: eventName,
    event = {},
  }: any) {
    // if (CleverTapAnalytics.user_id === '') {
    //   const user: any = await storageService.get(storageService.user);
    //   const _user = JSON.parse(user);

    //   if (_user) {
    //     CleverTapAnalytics.user_id = _user.userID;
    //     CleverTapAnalytics.configureProfile(
    //       _user.userID,
    //       `${_user.firstName} ${_user.lastName || ''}`,
    //       _user.email,
    //     );
    //   }
    // }

    // event.platform = 'web';
    // event.version = version;
    // event.platform_source = isMobile ? 'mobileweb' : 'web';
    // event.user_id = CleverTapAnalytics.user_id || -1;
    // // if (environment.production)
    // // else
    // CleverTapReact.event(eventName, event);
    // console.log(eventName, event);
  }
}